import React, { Component } from 'react';
import {
  Modal,
  Input,
  Divider,
  Avatar,
  message,
  Popconfirm,
  Typography,
  Button,
} from 'antd';
import { addLikeToStandup } from '../skills_action';
import { connect } from 'react-redux';
import { instances } from 'chart.js';

const { Text } = Typography;

class AbsencesModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false,
    };
  }

  render() {
    return (
      <Modal
        title={<b>Absences</b>}
        visible={this.props.showModal}
        onCancel={this.props.handleCancel}
        footer={null}
      >
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          {this.props.getUsersOnHoliday(false, true).map((name) => (
            <Text style={{ marginLeft: 16, marginBottom: 8 }}>{name}</Text>
          ))}
        </div>
      </Modal>
    );
  }
}

export default connect(null, { addLikeToStandup })(AbsencesModal);
